import { EDPCompanyColloquial, EDPPropertyColloquialDetail } from './models/edp/colloquials';
import { EDPRepresentativeInfo } from './models/edp/company-contact';
import { EDPElevatorBank } from './stacking-plan-container/floor-container/elevator-banks/elevator-banks.model';
import { EDPFloorSpaceInfo } from './stacking-plan-container/floor-container/floor/floor.model';

interface EDPEntity {
  entity_type: string;
  id: number;
  edp_last_update_date: string; // TODO: use moment
  edp_last_update_by: string;
  transaction_flag: string;
  edp_created_by: string;
  edp_created_date: string; // TODO: use moment
  edp_lineage: any[]; // TODO: add interface
  source_lineage: any[]; // TODO: add interface
}

interface EDPPostalAddressColloquial {
  id: number;
  full_street_name: string;
  full_address: string;
  address1: string;
  street1: string;
  street2: string;
  street_name: string;
  pre_street_direction_name: string;
  street_type: string;
  post_street_direction_name: string;
  city: string;
  district: string;
  state_province: string;
  postal_code: string;
  postal_code_extension: string;
  county: string;
  country: string;
  country_code_desc: string;
  language_desc: string;
}

export interface EDPPostalAddress {
  id: number;
  street1: string;
  street2: string;
  street_name: string;
  pre_street_direction_name: string;
  street_type: string;
  post_street_direction_name: string;
  city: string;
  state_province: string;
  postal_code: string;
  postal_code_extension: string;
  county: string;
  country: string;
  latitude: number;
  longitude: number;
  address_match_code: string;
  ref_postal_address_precision_type_code: string;
  ref_postal_address_precision_type_desc: string;
  ref_address_usage_type_desc: string;
  full_street_name: string;
  full_address: string;
  address1: string;
  district: string;
  cbre_owned_geocode_f: string;
  geocode_source_provider_type: string;
  addl_geocodes: any;
  colloquial: EDPPostalAddressColloquial[];
}

// Used to set a custom status for the data like when the BE is returning a server error
// so it can be used to show the data in a different way
export enum SPDataStatus {
  Default = 'Loaded',
  ServerError = 'SERVER_ERROR',
}

export interface EDPStackingPlan {
  entity: EDPEntity;
  property_name: string;
  ref_property_status_desc: string;
  year_property_built: number;
  number_elevator_bank: number;
  elevator_bank: EDPElevatorBank[];
  ref_property_class_type_desc: string;
  total_number_of_floors: number;
  number_of_floor_below_ground: number;
  total_gross_area: number;
  total_gross_area_uom_desc: string;
  net_rentable_area: number;
  net_rentable_area_uom_desc: string;
  typical_floor_area: number;
  typical_floor_area_uom_desc: string;
  minimum_floor_area: number;
  minimum_floor_area_uom_desc: string;
  maximum_floor_area: number;
  maximum_floor_area_uom_desc: string;
  colloquial: EDPPropertyColloquialDetail[];
  total_vacant_area: number;
  total_vacant_area_uom_desc: string;
  total_available_surface_area: number;
  total_available_surface_area_uom_desc: string;
  postal_address: EDPPostalAddress;
  property_owners: EDPCompanyInfo[];
  listing_reps: EDPRepresentativeInfo[];
  usages: any[]; // TODO: add interface [UsageInfo];
  floors: EDPFloorSpaceInfo[];
  property_review_by: string;
  property_review_ts: string;
  total_vacancy_area?: number;
  total_vacancy_area_uom_desc?: string;
  dataStatus?: SPDataStatus;
  is_empty_space_highlighted?: boolean;
  is_selected_usage_primary?: boolean;
  has_usage_primary?: boolean;
}

export interface DefaultLocaleInfo {
  languageCode: string;
  countryCode: string;
}

export interface SelectedProperty {
  entityName: string;
  propertyId: number;
  remainingSpace?: number;
  remainingSpaceUOM?: string;
}

export interface RemainingSpace {
  propertyId: number;
  remainingSpace?: number;
  remainingSpaceUOM?: string;
}

export interface PropertyData {
  postalAddress: EDPPostalAddress;
  propertyName: string;
}

export interface EDPCompanyInfo {
  company_id?: number | number[];
  company_name: string;
  company_legal_name: string;
  company_trade_name: string;
  ultimate_parent_company_name: string;
  party_organization_display_name: string;
  ref_cbre_industry_code_desc: string;
  ref_industry_classification_desc: string;
  colloquial: EDPCompanyColloquial[];
}

export interface LovValues {
  key: string | boolean | number;
  value: string;
}

export interface MappedLov {
  [key: string]: string;
}

export type StackingPlanAPI = 'stack' | 'stack2';

export interface AskingRateRangeObject {
  minAskingRate: number;
  minAskingUom: string;
  maxAskingRate: number;
  maxAskingUom: string;
}

export interface CBREEmployee {
  work_email: string;
  first_name: string;
  last_name: string;
  employee_id: string;
}

export interface StackingPlanReviewer {
  reviewedBy: string;
  reviewedOn: string;
}
